import { useHasPermissions } from '../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { useListFeaturesQuery } from '../../../../API/administration/FeaturesAPI';
import { useMemo } from 'react';
import { IFeatureRoleData } from '../../../../types/administration/features/IFeature';

const featureRoleComparator = (a: IFeatureRoleData, b: IFeatureRoleData): number => {
  if (a.name === b.name) {
    return a.roleName > b.roleName ? 1 : -1;
  }
  return a.name > b.name ? 1 : -1;
};

export const useListFeatureRoles = () => {
  const hasReadPermission = useHasPermissions([ePermissions.FeatureRead]);

  const {
    data: sortedGlobalFeatures = [],
    error,
    isFetching,
  } = useListFeaturesQuery(undefined, { skip: !hasReadPermission });

  const sortedFeatureRoleData = useMemo(() => {
    return sortedGlobalFeatures
      .flatMap((feature) => feature.roles)
      .map(({ compositeKey, name, roleId, ...rest }: IFeatureRoleData) => ({
        compositeKey: `${name}-${roleId}`,
        name,
        roleId,
        ...rest,
      }))
      .toSorted(featureRoleComparator);
  }, [sortedGlobalFeatures]);
  return { sortedFeatureRoleData, sortedGlobalFeatures, featureRoleError: error, isFeatureRoleFetching: isFetching };
};
